import { cn } from "../../lib/cn";
import { SCHEDULE_DAYS } from "../../utils/scheduleUtils";

export function DayOfWeekPicker({
  value,
  onChange,
  disabled = false,
  className,
}) {
  return (
    <div
      className={cn("grid grid-cols-7 gap-1", className)}
      role="radiogroup"
      aria-label="Day of week"
    >
      {SCHEDULE_DAYS.map((day) => {
        const active = value === day.value;
        return (
          <button
            key={day.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange?.(day.value)}
            className={cn(
              "h-10 rounded-lg text-xs font-semibold transition-colors",
              active
                ? "bg-brand text-white shadow-sm"
                : "border border-border bg-card text-muted-foreground hover:bg-muted/70 hover:text-foreground",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {day.label}
          </button>
        );
      })}
    </div>
  );
}
